import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { DataItemFormatter } from '@creditsights/styleguide-web';
import styles from './CompanyLinkRenderer.module.scss';

const cx = classNames.bind(styles);

export interface CompanyLinkRendererProps {
  getLink: (item) => string;
  isOpenInNewTab: boolean;
  stopMouseUpPropagation?: boolean;
  isHidden?: (item) => boolean;
}

const CompanyLinkRenderer: DataItemFormatter<string, ReactElement | null, CompanyLinkRendererProps> = ({
  value: displayName,
  props,
  item,
}) => {
  const link = props?.getLink(item) || '';
  const isOpenInNewTab = props?.isOpenInNewTab;
  const stopMouseUpPropagation = props?.stopMouseUpPropagation;
  const isHidden = props?.isHidden?.(item);

  const onMouseUp = (e) => {
    if (stopMouseUpPropagation) {
      e.stopPropagation();
    }
  };

  if (isHidden) {
    return null;
  }

  return (
    <Link
      className={cx('body')}
      key={displayName}
      onMouseUp={onMouseUp}
      target={isOpenInNewTab ? '_blank' : '_self'}
      to={link}
    >
      <h2 className={cx('title')}>{displayName}</h2>
    </Link>
  );
};

export default CompanyLinkRenderer;
